import { Controller } from "@hotwired/stimulus"
import { setCookie } from "../utils/cookies"

// data-controller="mobile-app-banner"
export default class extends Controller {
  close() {
    this.element.classList.add('hidden')
    setCookie('mobile_app_banner_closed', '1', 1)
  }
}
